
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { useSnackbar } from 'notistack';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import AddInteriorItem from './AddInteriorItem'
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import RemarksDynamicField from "../../../shared/components/RemarksDynamicField";
import { downloadFileType } from "../../../utils";
import { assetTypeValues, backendDateFormat } from "../../../constants";
import moment from "moment";
import { trackActivity } from "../../../utils/mixpanel";
import { avationPlcInstance, titanAviInstance, mtInstance } from "../../../shared/components";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { arrayMoveImmutable } from "array-move";
import { regexConstants } from "../../../constants/regEx";
import { DropzoneArea } from "material-ui-dropzone";
import AttachmentsRow from "../../../shared/components/AttachmentsRow";
import { assetValueKey } from "../../fleet";
import CustomChip from "../../../shared/components/CustomChip";
import PreviewDocsModal from "../../../shared/components/PreviewDocsModal";
const cargoCompObj = {
    location: '',
    capacity: '',
    remarks: '',
}
const CargoCompHd = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '120px' }}>Action(s)</TableCell>
                <TableCell>Cargo Location</TableCell>
                <TableCell>Cargo Capacity</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell>Attachment(s)</TableCell>
            </TableRow>
        </TableHead>
    )
}

const SortableBodyContainer = SortableContainer(({ cargoCompList, setAddEditCargoComp, setDeleteCargoComp }) => {
    return (
        <TableBody>
            {cargoCompList.list.map((item, index) =>
                <CargoCompList
                    key={`item-${index}`}
                    index={index}
                    sortIndex={index}
                    item={item}
                    onEdit={() => setAddEditCargoComp({ modal: true, data: item })}
                    onDelete={() => setDeleteCargoComp({ modal: true, data: item })}
                />
            )}
        </TableBody>
    );
});
const DragHandle = SortableHandle(() => <span style={{ paddingRight: '10px', display: 'inline-block', cursor: 'move', width: '10%' }}><DragIndicatorIcon /></span>)
const CargoCompList = SortableElement(({ item, onEdit, onDelete }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (id) => {
        setShowMore({
            ...showMore,
            [id]: !showMore[id],
        });
    };
    return (
        <TableRow>
            <TableCell align="left" style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
                <ul className="list-inline" style={{ width: '120px' }}>
                    {
                        checkPermission('technical_specs', 'interior', 'U') ?
                            <li className="list-inline-item hover-inline" onClick={onEdit}>
                                <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    {
                        checkPermission('technical_specs', 'interior', 'D') ?
                            <li className="list-inline-item hover-inline" onClick={onDelete}>
                                <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    <li className="list-inline-item hover-inline"><DragHandle /></li>
                </ul>
            </TableCell>
            <TableCell>
                <div style={{ width: '180px' }}>{item?.location || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ width: '180px' }}>{item?.capacity || '--'}</div>
            </TableCell>
            <TableCell>
                <RemarksDynamicField
                    item={item}
                />
            </TableCell>
            <TableCell>{item?.attachments?.length > 0 ? <AttachmentsRow attachmentsData={item?.attachments} /> : "--"}</TableCell>
        </TableRow>
    )
})
const AddEditCargoComp = ({ params, addEditCargoComp = {}, toggleModalFn, getResponseBack, assetInfoData, setPreviewDocs }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [cargoComp, setCargoComp] = useState(addEditCargoComp.data);
    const [error, setError] = useState({});
    const [deleteAttachment, setdeleteAttachment] = useState({ modal: false, data: null });

    const onFieldChange = (key, value) => {
        setCargoComp({ ...cargoComp, [key]: value });
    }

    const addAttachment = (id, data) => {
        let formdata = new FormData()
        data.map(item => {
            formdata.append('files', item)
        })
        formdata.append('asset_type', assetValueKey[params?.type])
        formdata.append('asset_slug', params.aircraft_slug)
        formdata.append('model_type', 1)
        formdata.append('object_id', id)
        setLoading(true)
        globalPostService(`/console/attachments/`, formdata)
            .then(response => {
                if (checkApiStatus(response)) {
                    toggleModalFn(); getResponseBack();
                    setLoading(false)
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                } else {
                    setLoading(false)
                    toggleModalFn(); getResponseBack();
                    // enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
            })
    }

    const onAddEditCargoComp = () => {
        let validationInputs = {
            location: cargoComp?.location?.trim()?.length ? '' : 'Please enter Cargo Location',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            if (cargoComp.id) {
                globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/interior/cargo-components/${cargoComp.id}/`, cargoComp)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            if (cargoComp?.files?.length) {
                                addAttachment(cargoComp.id, cargoComp?.files)
                            } else {
                                setLoading(false);
                            }
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            trackActivity('Console Management', { data:JSON.stringify(cargoComp), page_title: 'Cargo Component', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Cargo Component data from Edit form' })
                            if (!cargoComp?.files?.length) { toggleModalFn(); getResponseBack(); }
                        }
                    })
            } else {
                globalPostService(`console/v2/${params.type}/${params.aircraft_slug}/interior/cargo-components/`, cargoComp)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            if (cargoComp?.files?.length) {
                                addAttachment(response?.data?.data?.id, cargoComp?.files)
                            }else{
                                setLoading(false);
                            }
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            trackActivity('Console Management', {data:JSON.stringify(cargoComp), page_title: 'Cargo Component', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Edited Cargo Component data from Edit form' })
                            if (!cargoComp?.files?.length) { toggleModalFn(); getResponseBack(); }
                            
                        }
                    })
            }
        } else {
            setError(validationInputs);
        }
    }
    const DeleteCargoAttachment = (item) => {
        setLoading(true)
        globalDeleteService(`console/attachments/${item.uuid}/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    const updatedAttachments = cargoComp.attachments.filter(att => att.uuid !== item.uuid);
                    setCargoComp({ ...cargoComp, attachments: updatedAttachments });
                    setdeleteAttachment({ modal: false, data: null })
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
                setLoading(false)
            })
    };
    return (<>
        <Dialog
            open={addEditCargoComp.modal}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {cargoComp.id ? 'Edit ' : 'Add '} Cargo Compartment
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <TextField
                            required
                            name='Cargo_Location'
                            label='Cargo Location'
                            value={cargoComp?.location || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('location', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 100 }}
                            error={error?.location}
                            helperText={error?.location || ''}
                            onFocus={() => setError({ ...error, 'location': '' })}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            name='Cargo_Capacity'
                            label='Cargo Capacity'
                            value={cargoComp?.capacity || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('capacity', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 150 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            name='remarks'
                            label='Remarks'
                            value={cargoComp?.remarks || ''}
                            fullWidth
                            multiline
                            rows={3}
                            margin="normal"
                            onChange={(e) => onFieldChange('remarks', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 250 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={12}>
                        <div>
                            <DropzoneArea
                                acceptedFiles={['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'application/pdf']}
                                filesLimit={10}
                                maxFileSize={104857600}
                                showPreviewsInDropzone={false}
                                useChipsForPreview={true}
                                showPreviews={true}
                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                dropzoneClass="drag-drop-cnt"
                                showAlerts={['info', 'error']}
                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                clearOnUnmount={true}
                                onChange={(files) => { setCargoComp({ ...cargoComp, 'files': files }) }}
                            />
                        </div>
                        <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Supported extension ('.pdf, images/').</span><br />
                        {cargoComp?.attachments?.length ? cargoComp?.attachments && cargoComp?.attachments.map((file, index) => (
                            <CustomChip
                                style={{ marginRight: '4px', marginTop: '7px' }}
                                title={file.name}
                                index={index}
                                label={file.name.substring(0, 14) + '...'}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPreviewDocs(file); }}
                                onDelete={() => setdeleteAttachment({ modal: true, data: file })}
                            />
                        )) : null}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditCargoComp} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'SAVE'}
                </Button>
            </DialogActions>
        </Dialog>
        {deleteAttachment.modal ?
            <DeletePopUp
                modal={deleteAttachment.modal}
                title={`Delete Attachment (${deleteAttachment?.data?.name})`}
                content={`Are you sure, you want to Delete?`}
                toggleModalFn={() => setdeleteAttachment({ modal: false, data: null })}
                deleteRecordFn={() => DeleteCargoAttachment(deleteAttachment?.data)}
                isLoading={isLoading}
            /> : null
        }
        {isLoading ? <PageLoader /> : null}
    </>
    )
}
const CargoComp = ({ params, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [cargoCompList, setCargoComp] = useState({ list: [], pagination: null });
    const [addEditCargoComp, setAddEditCargoComp] = useState({ modal: false, data: null });
    const [deleteCargoComp, setDeleteCargoComp] = useState({ modal: false, data: null });
    const [previewDocs, setPreviewDocs] = useState("")
    useEffect(() => {
        getCargoComp({per_page:50}, 'skeletonLoader');
    }, []);
    const getCargoComp = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/interior/cargo-components/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setCargoComp(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteCargoComp = () => {
        setLoading(true);
        globalDeleteService(`console/v2/${params.type}/${params.aircraft_slug}/interior/cargo-components/${deleteCargoComp.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteCargoComp({ modal: false, data: null })
                    getCargoComp({per_page: cargoCompList?.pagination?.per_page}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    const onExportCargoComp = () => {
        setLoading(true);
        globalExportService(`console/v2/aircraft/${params.aircraft_slug}/interior/cargo-components/?download=xls`)
            .then(response => {
                downloadFileType(response, `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}CargoComponent ${moment().format(backendDateFormat)}`, 'xlsx')
                trackActivity('Console Management', { page_title: 'Cargo Component', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Exported', event_desc: `Cargo Component Exported Successfully`, file_extension: 'xlsx' })
                setLoading(false)
            });
    }
    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex !== newIndex) {
            let newArray = arrayMoveImmutable(cargoCompList?.list, oldIndex, newIndex)
            setLoading(true)
            setCargoComp({ ...cargoCompList, list: newArray })
            globalPutService(`console/v2/aircraft/${params.aircraft_slug}/interior/cargo-components/reorder/`, { order_list: newArray.map(item => item.id) })
                .then(response => {
                    setLoading(false)
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                })
        }
    }
    return (
        <div style={{ padding: '0px 10px' }}>
            {skeletonLoader ? <STableLoader count={6} size={7} /> :
                <>
                    <AddInteriorItem
                        addPermission={checkPermission('technical_specs', 'interior', 'C')}
                        exportPermission={checkPermission('technical_specs', 'interior', 'EXP')}
                        onAddItem={() => setAddEditCargoComp({ modal: true, data: cargoCompObj })}
                        item={cargoCompList}
                        isExport
                        isImport
                        onExport={() => onExportCargoComp()}
                        getResponseBack={() => getCargoComp({}, 'skeletonLoader')}
                        url={`/console/v2/aircraft/${params.aircraft_slug}/interior/cargo-components/import/`}
                    />
                    <Paper square>
                        <div style={{height:`${window.innerHeight -  (cargoCompList?.list?.length ? 330 : 280)}px`,overflow:'auto',marginTop: "3px" }}>
                        <Table className='mui-table-format' stickyHeader>
                            <CargoCompHd />
                            <SortableBodyContainer
                                useDragHandle
                                onSortEnd={onSortEnd}
                                cargoCompList={cargoCompList}
                                setAddEditCargoComp={setAddEditCargoComp}
                                setDeleteCargoComp={setDeleteCargoComp}
                            />
                        </Table>
                        {!cargoCompList?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    {cargoCompList?.pagination ?
                        <Paper square>
                            <Pagination
                                pagination={cargoCompList.pagination}
                                onChangePage={(event, newPage) => getCargoComp({ ...filter, page: newPage + 1, per_page: cargoCompList.pagination.per_page }, 'pageLoader')}
                                onChangeRowsPerPage={(event) => getCargoComp({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                            />
                        </Paper>
                        : null
                    }
                </>
            }

            {addEditCargoComp.modal ?
                <AddEditCargoComp
                    assetInfoData={assetInfoData}
                    params={params}
                    addEditCargoComp={addEditCargoComp}
                    toggleModalFn={() => setAddEditCargoComp({ modal: false, data: null })}
                    getResponseBack={() => getCargoComp({per_page: cargoCompList?.pagination?.per_page}, 'pageLoader')}
                    setPreviewDocs={setPreviewDocs}
                /> : null
            }
            {deleteCargoComp.modal ?
                <DeletePopUp
                    modal={deleteCargoComp.modal}
                    title='Delete Cargo Component'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteCargoComp({ modal: false, data: null })}
                    deleteRecordFn={onDeleteCargoComp}
                /> : null
            }
            {previewDocs ? (
                <PreviewDocsModal previewDocs={previewDocs} toggleModalFn={() => setPreviewDocs("")} />
            ) : null}

            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(CargoComp);
